import { render, staticRenderFns } from "./UsuariosCrm.vue?vue&type=template&id=dfc84eca&"
import script from "./UsuariosCrm.vue?vue&type=script&lang=js&"
export * from "./UsuariosCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports